import { isLivePopupReason } from './template-props'

// The controller suppresses preview impressions and cooldowns; CTA events
// are delegated from the DOM and must opt out independently, including
// phone/image links and Storyblok inline previews.
export const popupClickTracking = (reason?: string | null) => ({
  'data-track': isLivePopupReason(reason) ? true : undefined,
  'data-tracking': isLivePopupReason(reason) ? undefined : ('ignore' as const),
})
